var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33341 11.333C6.96675 11.333 6.66675 11.633 6.66675 11.9997C6.66675 12.3663 6.96675 12.6663 7.33341 12.6663C7.70008 12.6663 8.00008 12.3663 8.00008 11.9997C8.00008 11.633 7.70008 11.333 7.33341 11.333Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 11.333C11.6334 11.333 11.3334 11.633 11.3334 11.9997C11.3334 12.3663 11.6334 12.6663 12.0001 12.6663C12.3667 12.6663 12.6667 12.3663 12.6667 11.9997C12.6667 11.633 12.3667 11.333 12.0001 11.333Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 11.333C16.3001 11.333 16.0001 11.633 16.0001 11.9997C16.0001 12.3663 16.3001 12.6663 16.6667 12.6663C17.0334 12.6663 17.3334 12.3663 17.3334 11.9997C17.3334 11.633 17.0334 11.333 16.6667 11.333Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.27f27fff87def39635427e63f1574ab6.svg";
export { ForwardRef as ReactComponent };